import React, { useState, useEffect } from "react";
import {
    Box,
    Card,
    CardContent,
    CardHeader,
    Grid,
    Paper,
    Tooltip,
    Typography,
    Button 
} from "@mui/material";
import theme, {
    textClasses,
    buttonClasses 
} from "../../../static/styles/theme";
import {
    getFieldsLayoutForEntry,
} from "../../Components/TemplateInputConfiguration";
import ViewSlotBookingDetail from "../../Components/BookingSlot/ViewSlotBookingDetail";
import { lsGet } from '../../../utils/hooks';
import { generateUniqueSerialNumber } from "../../../redux/actions";
import { useDispatch, useSelector } from "react-redux";
import { showToast} from "../../../services/functions";

const ShipmentSection = ({ formHooks, template, shipmentMasterId, slotBookingField = false }) => {
    const { register, control, setValue, errors } = formHooks;
    const dispatch = useDispatch();
    const [loader, setLoader] = useState("");
    const [templateHeader, setTemplateHeader] = useState(null);
    const [bookedSlotData, setBookedSlotData] = useState({});
    const [soGenerated, setSOGenerated] = useState(false);
    
    function autoFillOnFocus() { }

    const layout = getFieldsLayoutForEntry(
        (template?.attributes?.length > 0 && template?.attributes) || [],
        register,
        control,
        autoFillOnFocus,
        errors
    );
    const dispatchOrderNoGenerator = () => {
        setLoader("fetchSONumber");
        dispatch(
          generateUniqueSerialNumber(
            { templateId: template?._id || "", serialNumberType: "salesOrder" },
            ({ success = false, message, data = "" }) => {
              showToast(message, !success);
              setTimeout(() => {
                setLoader("");
              }, 500)
              if (success) {
                formHooks.setValue("salesDetailID", data);
                // setPOGenerated(true);
              }
            }
          )
        );
      };
    
      useEffect(() => {
        const updateSlotBookedData = () => {
          const slotBookedData = lsGet("e-slotsBooked");
          setBookedSlotData(slotBookedData ? slotBookedData : {});
        };
    
        // Initial fetch
        updateSlotBookedData();
    
        // Event listener for storage changes
        const handleStorageChange = (event) => {
          if (event.key === "e-slotsBooked") {
            updateSlotBookedData();
          }
        };
    
        window.addEventListener("storage", handleStorageChange);
    
        // Cleanup listener on unmount
        return () => {
          window.removeEventListener("storage", handleStorageChange);
        };
      }, []);
    
    return (
        <>
            <Grid
                container
                sx={{
                    marginTop: "2%",
                    width: "95%",
                    marginLeft: "auto",
                    marginRight: "auto",
                }}
            >
                <Grid item sm={12} xs={12}>
                    <Card sx={{ borderRadius: "8px" }}>
                        <CardHeader
                            sx={{
                                p: 2,
                                borderRadius: "8px 8px 0px 0px",
                                backgroundColor: theme.themeGray,
                                color: "black",
                                boxShadow: "0px 1px 10px gray",
                            }}
                            title={
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                    }}
                                >
                                    <Typography sx={{ ...textClasses.normalText }}>
                                        1. Shipment Details
                                    </Typography>
                                    {template?.attributes?.find(
                                        (dl) => dl?._id == "salesDetailID"
                                    ) && (
                                            <Button
                                                style={{ ...buttonClasses.lynkitOrangeEmpty }}
                                                onClick={() => dispatchOrderNoGenerator()}
                                                disabled={loader == "fetchSONumber" || soGenerated}
                                            >
                                                Generate{" "}
                                                {template?.attributes?.find(
                                                    (dl) => dl?._id == "salesDetailID"
                                                )?.label || "SO Number"}
                                            </Button>
                                        )}
                                </Box>
                            }
                        />
                        <CardContent>
                            <Grid container sx={{ mb: 1 }} spacing={2}>
                                {layout.single.map((field, i) => {
                                    // if(field._id=="saleOrderId" && poGenerated){
                                    //     field.disabled = true
                                    // }
                                    return (
                                        <Grid
                                            container
                                            item
                                            xs={12}
                                            sm={4}
                                            justifyContent={"center"}
                                            alignItems="center"
                                            key={i}
                                        >
                                            {field}
                                        </Grid>
                                    );
                                })}
                            </Grid>

                            <Grid container spacing={2} sx={{ pt: 1 }}>
                                {layout.multi.map((field, i) => {
                                    return (
                                        <Grid
                                            container
                                            item
                                            xs={12}
                                            sm={4}
                                            justifyContent={"center"}
                                            alignItems="center"
                                            key={i}
                                        >
                                            {field}
                                        </Grid>
                                    );
                                })}
                            </Grid>
                            {slotBookingField && 
                                <ViewSlotBookingDetail
                                    bookedSlotData={bookedSlotData || {}}
                                    resetBookedSlotData={() => {
                                        setBookedSlotData({})
                                    }}
                                    isInternal={false}
                                />
                            }
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </>
    );
};

export default ShipmentSection;